import { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.background.paper,
}

export const contentGridSx: SxProps<Theme> = {
  maxWidth: {
    xs: '100%',
    lg: '111.2rem',
    xl: '151.6rem',
  },
  margin: 'auto',
  columnGap: {
    lg: '4.8rem',
  },
  alignItems: 'center',
  padding: {
    xs: '2.4rem',
    md: '2.4rem 5.6rem',
    lg: 0,
  },
}

export const unlockActionableLeadsAndCloseMoreDealsLeftSideWrapperSx: SxProps<Theme> =
  {
    height: {
      xs: 'auto',
      lg: '59.6rem',
      xl: '60.8rem',
    },
    display: 'flex',
    alignItems: 'center',
    order: {
      xs: 1,
      lg: 'initial',
    },
    padding: {
      xs: '0 0 2.4rem',
      md: '2.4rem 0',
      lg: 0,
    },
  }

export const unlockActionableLeadsAndCloseMoreDealsLeftSideContentSx: SxProps<Theme> =
  {
    gap: {
      xs: '1.6rem',
      md: '2.4rem',
    },
  }

export const unlockActionableLeadsAndCloseMoreDealsRightSideWrapperSx: SxProps<Theme> =
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    order: {
      xs: 2,
      lg: 'initial',
    },
    paddingBottom: {
      xs: '2.4rem',
      lg: 0,
    },
    borderBottom: {
      xs: '0.1rem solid rgba(0, 0, 0, 0.12)',
      lg: 0,
    },
  }

export const unlockActionableLeadsAndCloseMoreDealsRightSideImageSx: SxProps<Theme> =
  {
    width: {
      xs: '83%',
      lg: '53.2rem',
      xl: '55.2rem',
    },
    maxWidth: {
      md: '55.7rem',
      lg: '100%',
    },
  }

export const modernizeYourLeadGenerationForTheEvolvingItBuyerLeftSideWrapperSx: SxProps<Theme> =
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: {
      xs: 'auto',
      lg: '69.2rem',
      xl: '66.4rem',
    },
    order: {
      xs: 4,
      lg: 'initial',
    },
    paddingTop: {
      xs: '1rem',
      md: 0,
    },
    paddingBottom: {
      xs: '3rem',
      md: '2.4rem',
      lg: 0,
    },
    borderBottom: {
      xs: '0.1rem solid rgba(0, 0, 0, 0.12)',
      lg: 0,
    },
  }

export const modernizeYourLeadGenerationForTheEvolvingItBuyerLeftSideImageSx: SxProps<Theme> =
  {
    width: {
      xs: '100%',
      lg: '53.2rem',
      xl: '72.2rem',
    },
    maxWidth: {
      md: '72.2rem',
      lg: '100%',
    },
  }

export const modernizeYourLeadGenerationForTheEvolvingItBuyerRightSideWrapperSx: SxProps<Theme> =
  {
    display: 'flex',
    alignItems: 'center',
    order: {
      xs: 3,
      lg: 'initial',
    },
    padding: {
      xs: '2.4rem 0',
      lg: 0,
    },
  }

export const modernizeYourLeadGenerationForTheEvolvingItBuyerRightSideContentSx: SxProps<Theme> =
  {
    gap: {
      xs: '1.6rem',
      md: '2.4rem',
    },
  }

export const unlockThePowerOfAuthenticConnectionsLeftSideWrapperSx: SxProps<Theme> =
  {
    height: {
      xs: 'auto',
      lg: '62.4rem',
      xl: '59.6rem',
    },
    display: 'flex',
    alignItems: 'center',
    order: {
      xs: 5,
      lg: 'initial',
    },
    padding: {
      xs: '2.4rem 0',
      lg: 0,
    },
  }

export const unlockThePowerOfAuthenticConnectionsLeftSideContentSx: SxProps<Theme> =
  {
    width: '105%',
    gap: {
      xs: '1.6rem',
      md: '2.4rem',
    },
  }

export const unlockThePowerOfAuthenticConnectionsRightSideWrapperSx: SxProps<Theme> =
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    order: {
      xs: 6,
      lg: 'initial',
    },
    paddingTop: {
      xs: '1rem',
      md: 0,
    },
    paddingBottom: {
      xs: '1rem',
      md: '2.4rem',
      lg: 0,
    },
  }

export const unlockThePowerOfAuthenticConnectionsRightSideImageSx: SxProps<Theme> =
  {
    width: {
      xs: '100%',
      lg: '52rem',
      xl: '72.2rem',
    },
    maxWidth: {
      md: '72.2rem',
    },
  }

export const dividerWrapperSx: SxProps<Theme> = { padding: '0 !important' }

export const titleSx: SxProps<Theme> = {
  color: (theme) => theme.palette.primary.main,
}

export const unlockPowerAuthenticConnectionsSx: SxProps<Theme> = {
  ...titleSx,
  width: {
    xl: '110%',
  },
}

export const unlockActionableLeadsAndCloseMoreDealsBulletPointsSx: SxProps<Theme> =
  {
    width: {
      md: '101%',
      lg: '104%',
    },
  }

export const modernizeYourLeadGenerationForTheEvolvingItBuyerBulletPointsSx: SxProps<Theme> =
  {
    width: {
      xs: '100.6%',
      md: '100%',
    },
  }

export const unlockPowerAuthenticConnectionsBulletPointsSx: SxProps<Theme> = {
  width: {
    md: '100.4%',
    lg: '100%',
  },
}
